import type { Locale } from "~/core/i18n/index";

/**
 * One half of an `[en, zh]` pair: the reader's.
 *
 * The keyed table and the Agent's copy hold this product's sentences. What
 * the server sends — a plan's name, a template's description, a platform
 * field's label — arrives in both languages already, as a tuple or as
 * `name_en`/`name_zh`, and this is the one place that chooses between them.
 * Written as a pair at the call site either way, so the English is always
 * the first half and nobody has to remember which spelling a field used.
 *
 * No fallback to the other language: an English hint in a Chinese form reads
 * as a field somebody forgot to finish. A caller with a better fallback — the
 * raw key, a placeholder — writes it after `??` or `||`. An unsupported locale
 * (a stale cookie) reads English, as `t` does.
 *
 * A pair is typed as an array rather than a tuple because some of them come
 * out of JSON files, whose arrays TypeScript cannot count.
 */
export function pick<T>(locale: Locale, pair: readonly T[]): T;
export function pick<T>(locale: Locale, pair: readonly T[] | null | undefined): T | undefined;
export function pick<T>(locale: Locale, pair: readonly T[] | null | undefined): T | undefined {
	return pair?.[locale === "zh" ? 1 : 0];
}
